import React from 'react';

type Props = {
  ref: React.RefObject<HTMLElement>;
};

function useDnDActiveObserver({ ref }: Props) {
  const [isDnDActive, setIsDndActive] = React.useState(false);

  React.useEffect(() => {
    if (!ref?.current) return;

    const observer = new MutationObserver(() => {
      const hasAriaPressedTrue = !!ref.current?.querySelector('div[aria-pressed="true"]');
      setIsDndActive(hasAriaPressedTrue);
    });

    observer.observe(ref.current, { attributes: true, childList: true, subtree: true });

    return () => observer.disconnect();
  }, [ref.current]);

  return { isDnDActive };
}

export { useDnDActiveObserver };
